import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import {Stepper} from "../Stepper/Stepper";
import {DynamicFieldComponent} from "../DynamicFieldComponent/DynamicFieldComponent";
import {Button, MenuItem, TextField, makeStyles} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import {ActFillingHeader} from "./ActFillingHeader/ActFillingHeader";
import {ActFillingFooter} from "./ActFillingFooter/ActFillingFooter";
import {Statuses} from "../../utils/actStatuses";
import {UserRoles} from "../../utils/roles";
import {Comment} from "./Comment/Comment";
import { getActTemplateField } from "../../redux/reducers/act-template-reducer";
import { useSelector } from "react-redux";
import { useDialog } from "../../hooks/useDialog";
import { Dialog } from "../Dialog/Dialog";
import { Autocomplete } from "@material-ui/lab";

const useStyles = makeStyles(() => ({
    stepperGrow: {
        flexGrow: 1
    },
    dialogContentRoot: {
        padding: '0 16px',
    }
}))

const getDynamicFieldKey = (id) => `${id}-dynamic-field-act-filling`

const getDynamicFieldIsDisabled = (status, role, isStaff) => {
    
    if (isStaff) {
        return false
    }
    
    if (status === Statuses.APPROVED_STATUS) {
        return true
    }
    
    if (role === UserRoles.PROJECT_MANAGER) {
        return false
    }    

    if (role === UserRoles.MODERATOR) {
        return false
    }
    
    if (role === UserRoles.EDITOR) {
        return false
    }        
    
    if (role === UserRoles.SUPERVISOR) {
        if (status !== Statuses.STATUS_SIGNED ) {
            return false
        }
    }

    if (role === UserRoles.FIELD_CONTRACTOR) {
        if (status !== (Statuses.STATUS_SIGNED | Statuses.APPROVED_STATUS)) {
            return false
        }
    }

    return true
}

const getIsCommentShown = (status, role, isStaff) => {
    if (isStaff || role === UserRoles.EDITOR) {
        return true
    }
    if (role === UserRoles.SUPERVISOR) {
        if (status === Statuses.FOR_APPROVAL_STATUS) {
            return false
        }
        if (status === Statuses.REJECTED_STATUS) {
            return true
        }
    }
    if (role === UserRoles.PROJECT_MANAGER || role === UserRoles.MODERATOR) {
        if (status === Statuses.FOR_APPROVAL_STATUS || status === Statuses.REJECTED_STATUS) {
            return true
        }
    }
    if (role === UserRoles.FIELD_CONTRACTOR) {
        if (status === Statuses.FOR_APPROVAL_STATUS) {
            return false
        }
        if (status === Statuses.REJECTED_STATUS) {
            return true
        }
    }
    return false
}

export const ActFilling = ({
                               id,
                               name,
                               steps,
                               activeStep,
                               errorSteps,
                               nextStep,
                               prevStep,
                               touched,
                               errors,
                               status,
                               getFieldProps,
                               setFieldValue,
                               setFieldTouched,
                               actTemplate,
                               comments,
                               creator,
                               user,
                               files,
                               handleCommentsChange,
                               handleStatusChange,
                               handleActScan,
                               handleSaveActDraftButton,
                               handleCreateActButton,
                               handleAdminSaveButton,
                               handleActApproveButton,
                               handleActRejectButton,
                               handleDeleteActDraftButton,
                               values,
                               handleAdminSaveButtonLock,
                               handleCreateActButtonLock,
                               selectedAct,
                               supervisor,
                               setSupervisor,
                               youSupervisors,
                           }) => {
    const classes = useStyles()
    
    const field = useSelector(getActTemplateField) 

    const supervisorDialog = useDialog();

    const [localSupervisor, setLocalSupervisor] = useState(null)


    const FoterField = () => {
        let mass = []

        steps[0].map((field) => {
            mass.push(getFieldProps(field.variable))
        }) 
        steps[1].map((field) => {
            mass.push(getFieldProps(field.variable))
        }) 
        steps[2].map((field) => {
            mass.push(getFieldProps(field.variable))
        }) 
        
        
        return mass
    }


    const ActTempl = () => {
            
        return field
    }


    
    const chooseSupervisor = (event, newValue) => {
        setLocalSupervisor(newValue)
    }

    useEffect(() => {
        if (supervisor === null) {
            supervisorDialog.handleOpen()
        }
    },[])

   
    const isCommentShown = getIsCommentShown(status, user?.role, user?.is_staff)
    return <Grid container direction={"column"}>
        <Grid item xs={isCommentShown ? 9 : undefined}>
            <ActFillingHeader isStaff={user?.is_staff}
                              id={id}
                              name={name}
                              role={user?.role}
                              creator={creator}
                              status={status}
                              files={files}
                              handleSaveActDraftButton={handleSaveActDraftButton}
                              handleActApproveButton={handleActApproveButton}
                              handleActRejectButton={handleActRejectButton}
                              handleDeleteActDraftButton={handleDeleteActDraftButton}
                              handleActScan={handleActScan}
                              setFieldValue={setFieldValue}
                              supervisor={supervisor}
            />
        </Grid>
        <Grid item container spacing={2}>
            <Grid item container direction={"column"} xs={isCommentShown ? 9 : undefined}>
                <Grid item>
                    <Paper>
                        <Grid container>
                            <Grid item className={classes.stepperGrow}>
                                <Stepper activeStep={activeStep}
                                         stepNames={actTemplate?.content?.stepperConfig}
                                         errorSteps={errorSteps}
                                />
                            </Grid>
                        </Grid>
                        <Grid className={classes.dialogContentRoot} container direction={'column'} spacing={1}>
                            <Grid container item  spacing={3}>
                                {steps[activeStep].map(field => <Grid key={getDynamicFieldKey(field.id)} item xs={field?.widthFieldXs == 0 ? 12 : field?.widthFieldXs}>
                                        <DynamicFieldComponent  {...field }
                                                                touched={touched[field.variable]}
                                                                error={errors[field.variable]}
                                                                getFieldProps={getFieldProps(field.variable)}
                                                                AllgetFieldProps={getFieldProps}
                                                                {...getFieldProps(field.variable)}
                                                                setFieldValue={setFieldValue}
                                                                setFieldTouched={setFieldTouched}
                                                                disabled={getDynamicFieldIsDisabled(
                                                                    status,
                                                                    user?.role,
                                                                    user?.is_staff
                                                                )}
                                                                selectedAct={selectedAct}
                                                                supervisor={supervisor}
                                        />
                                    </Grid>
                                )}
                            </Grid>
                            <ActFillingFooter activeStep={activeStep}
                                              nextStep={nextStep}
                                              prevStep={prevStep}
                                              role={user?.role}
                                              isStaff={user?.is_staff}
                                              status={status || ''}
                                              handleStatusChange={handleStatusChange}
                                              handleCreateActButton={handleCreateActButton}
                                              handleAdminSaveButton={handleAdminSaveButton}
                                              pole={FoterField()}
                                              actTempl = {ActTempl()}
                                              setFieldValue={setFieldValue}
                                              values={values}
                                              handleAdminSaveButtonLock={handleAdminSaveButtonLock}
                                              handleCreateActButtonLock={handleCreateActButtonLock}


                            />
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
            {isCommentShown ?
                <Comment status={status}
                         role={user?.role}
                         isStaff={user?.is_staff}
                         comments={comments}
                         handleCommentsChange={handleCommentsChange}/> :
                null}
        </Grid>
        {user.role === UserRoles.FIELD_CONTRACTOR &&
           <Dialog
            open={supervisorDialog.open}
            title={'Необходимо выбрать супервайзера'}
            actions={<Button disabled = {localSupervisor === null} onClick={() => { setSupervisor(localSupervisor); supervisorDialog.handleClose()}}>Выбрать</Button>}
            maxWidth={"sm"} 
            fullWidth={true}
            >
                <div style={{margin: '20px'}}>
                    <Autocomplete
                        id={`${'youSupervisor'}`}
                        fullWidth
                        value={localSupervisor}
                        clearOnEscape
                        options={youSupervisors}
                        getOptionLabel={(option) => option.full_name}
                        renderInput={(params) => <TextField {...params}
                                                            variant={'outlined'}
                                                            size={"small"}
                                                            fullWidth
                                                            helperText={'Списое супервайзеров'}
                                                            label={'Супервайзеры'}/>}
                        onChange={chooseSupervisor}
                    />
                </div>
            </Dialog> 
        }
        
    </Grid>


}